import any from './any.js';
import array from './array.js';
import boolean from './boolean.js';
import date from './date.js';
import enumerable from './enum.js';
import floatFn from './float.js';
import integer from './integer.js';
import method from './method.js';
import number from './number.js';
import object from './object.js';
import pattern from './pattern.js';
import regexp from './regexp.js';
import required from './required.js';
import string from './string.js';
import type from './type.js';
var validators = {
  string: string,
  method: method,
  number: number,
  boolean: boolean,
  regexp: regexp,
  integer: integer,
  float: floatFn,
  array: array,
  object: object,
  enum: enumerable,
  pattern: pattern,
  date: date,
  url: type,
  hex: type,
  email: type,
  required: required,
  any: any
};
export { validators as default };
//# sourceMappingURL=index.js.map
